<!--
 * @Description: 业务区域 弹窗统一处理
 * @Author: yangsibo
 * @Date: 2022-05-12 10:24:14
 * @LastEditors: juanjuanhui
 * @LastEditTime: 2022-06-28 09:55:33
 * @FilePath: \YunYin_admin\src\views\Setting\BusinessArea\components\currentDialog.vue
-->
<template>
  <div class="current-dialog">
    <el-dialog
      class="dialog-selCooper"
      :title="dialogObj.label"
      :visible.sync="showDialog"
      :width="dialogObj.w"
      :before-close="close"
    >
      <el-form :model="currentForm" :rules="currentRules" ref="currentForm">
        <!-- 新增区域 下拉选择父级区域 -->
        <el-form-item
          label=""
          prop="parentId"
          v-if="showItem(dialogObj.id, 'select')"
        >
          <el-select
            style="text-overflow: ellipsis"
            ref="selectTree"
            v-model.trim="currentForm.parentId"
            placeholder="请选择所属区域"
            popper-class="select-tree"
            :disabled="dialogObj.id == 2"
          >
            <el-option
              :value="node.id"
              :key="node.id"
              :label="node.zoneName"
              style="height: auto"
            >
              <el-tree
                ref="selectedTree"
                :data="businessZoneList"
                node-key="id"
                default-expand-all
                :expand-on-click-node="false"
                :current-node-key="node.id"
                :props="{
                  children: 'children',
                  label: 'zoneName',
                }"
                @node-click="handleNodeClick"
              />
            </el-option> </el-select
        ></el-form-item>
        <!-- 新增区域/修改区域名称 -->
        <el-form-item
          label=""
          prop="zoneName"
          v-if="showItem(dialogObj.id, 'name')"
        >
          <el-input
            type="text"
            placeholder="请输入区域名称"
            v-model.trim.trim="currentForm.zoneName"
            maxlength="30"
          ></el-input>
        </el-form-item>
        <!-- 删除区域/业务员 -->
        <el-form-item
          v-if="showItem(dialogObj.id, 'delete')"
          class="delete-item"
        >
          {{ `是否确认删除${dialogObj.id === 5 ? "该区域" : "业务员"}？` }}
        </el-form-item>
        <!-- 新增业务员/设置负责人 -->
        <el-form-item
          v-if="showItem(dialogObj.id, 'person')"
          class="person-item"
        >
          <!-- 设置负责人 -->
          <template v-if="dialogObj.id == 4">
            <div class="person-title">区域成员</div>
            <div class="person-content">
              <el-checkbox-group
                v-if="areaPersonList.length > 0"
                v-model.trim="dutyIds"
                @change="changeIds"
              >
                <el-checkbox
                  :label="item.id"
                  v-for="item in areaPersonList"
                  :key="item.id"
                  >{{ item.personName }}</el-checkbox
                >
              </el-checkbox-group>
              <div class="person-emty" v-else>暂无数据</div>
            </div>
            <div class="selected" v-show="dutyCheckeds.length > 0">
              <span class="label">已选：</span>
              <div class="scroll">
                <ul>
                  <li v-for="(item, i) in dutyCheckeds" :key="item.id">
                    <span class="txt">{{ item.personName }}</span>
                    <i
                      class="el-icon-close"
                      @click="deleteItem(i, dutyCheckeds, item)"
                    ></i>
                  </li>
                </ul>
              </div>
            </div>
          </template>
          <!-- 新增业务员 -->
          <template v-else>
            <div class="person-filter">
              <el-input
                placeholder="搜索姓名"
                v-model.trim="keyWord"
                @keyup.enter.native="handleFilter"
              >
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
              </el-input>
              <el-button type="primary" class="filter-btn" @click="handleFilter"
                >查询</el-button
              >
            </div>
            <div class="person-content">
              <el-checkbox-group
                v-if="dutyPersonList.length > 0"
                v-model.trim="dutyIds"
                @change="changeDutyList"
              >
                <el-checkbox
                  :label="item.id"
                  v-for="item in dutyPersonList"
                  :key="item.id"
                  >{{ item.fullName }}</el-checkbox
                >
              </el-checkbox-group>
              <div class="person-emty" v-else>暂无数据</div>
            </div>
            <div class="selected" v-show="dutyCheckeds.length > 0">
              <span class="label">已选：</span>
              <div class="scroll">
                <ul>
                  <li v-for="(item, i) in dutyCheckeds" :key="item.id">
                    <span class="txt">{{ item.fullName }}</span>
                    <i
                      class="el-icon-close"
                      @click="deleteItem(i, dutyCheckeds, item)"
                    ></i>
                  </li>
                </ul>
              </div>
            </div>
          </template>
        </el-form-item>
        <!-- 底部按钮 -->
        <el-form-item class="foot-btns">
          <el-button type="primary" class="btn-cancel" @click="close"
            >取消</el-button
          >
          <el-button
            type="primary"
            class="btn-confirm"
            @click="confirmCurrent()"
            >{{ dialogObj.btn }}</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "CurrentDialog",
  props: {
    // 弹窗是否显示
    showDialog: {
      type: Boolean,
      default: false,
    },
    // 弹窗信息
    dialogObj: {
      type: Object,
      default: {},
    },
    // 区域树形结构数据
    businessZoneList: {
      type: Array,
      default: [],
    },
    // 当前节点数据
    areaData: {
      type: Object,
      default: {},
    },
    // 表格选中数据
    multipleSelection: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      currentForm: {}, // 当前表单提交参数
      currentRules: {}, // 当前表单验证
      // 不同表单对应绑定数据
      formObj: {
        1: {
          orderNum: 4,
          menuLevel: 1,
          menuIsChild: 1,
          zoneName: "",
          parentId: null,
        },
        2: {
          orderNum: 4,
          menuLevel: 1,
          menuIsChild: 1,
          zoneName: "",
          parentId: null,
        },
        3: {
          zoneName: "",
          id: "",
        },
        4: {
          ids: [],
          businessZoneId: "",
        },
        5: {
          id: "",
        },
      },
      node: {}, // 选择区域  选中节点
      areaPersonList: [], // 增加业务员列表
      keyWord: "", // 搜索关键字
      dutyPersonList: [], //
      dutyIds: [], // 新增业务员id集合
      dutyCheckeds: [], // 设置负责人人员列表
      optionPersonList: [], // 更换业务员列表
    };
  },
  computed: {
    // 展示表单项
    showItem() {
      return (id, type) => {
        let ids = {
          name: [1, 2, 3],
          select: [1, 2],
          form: [1, 2, 3],
          delete: [5, 10],
          person: [4, 8],
          change: [9],
        };
        return ids[type].includes(id);
      };
    },
    // 新增业务员列表过滤掉当前业务员
    optionList() {
      return (list, id) => {
        return list.filter((item) => {
          return item.id != id;
        });
      };
    },
  },
  methods: {
    /**
     * @description: 初始化数据
     * @Author: yangsibo
     * @Date: 2022-05-12 17:49:54
     */
    initData(val) {
      this.currentForm = this.formObj[val.id];
      switch (val.id) {
        case 1:
          this.currentForm.orderNum = this.businessZoneList
            ? this.businessZoneList.length + 1
            : 1;
          break;
        case 2:
          this.currentForm.orderNum = this.areaData.orderNum;
          this.currentForm.parentId = this.areaData.id;
          this.node = this.areaData;
          this.$nextTick(() => {
            this.$refs.selectedTree.setCurrentKey(this.node.id);
          });
          break;
        case 3:
          Object.assign(this.currentForm, this.areaData);
          break;
        case 4:
          this.specifiedDutyList(this.areaData.id);
          this.currentForm.businessZoneId = this.areaData.id;
          break;
        case 5:
          this.currentForm.id = this.areaData.id;
          break;
        case 8:
          this.addPersonList(this.areaData.id);
          break;
        default:
          break;
      }
    },
    /**
     * @description: 关闭弹窗
     * @Author: yangsibo
     * @Date: 2022-05-13 14:19:50
     */
    close() {
      this.$emit("close");
    },
    /**
     * @description: 保存当前表单
     * @Author: yangsibo
     * @Date: 2022-05-13 08:50:05
     */
    confirmCurrent() {
      switch (this.dialogObj.id) {
        case 1:
        case 2:
          this.insertMBusinessZone();
          break;
        case 3:
          this.updateMBusinessZoneNameById();
          break;
        case 4:
          this.specifiedDuty(this.getParams(4));
          break;
        case 5:
          this.deleteMBusinessZoneNameById();
          break;
        case 8:
          this.batchAddPerson(this.getParams(8));
          break;
        case 10:
          this.batchDelPerson(this.multipleSelection);
          break;
        default:
          break;
      }
    },
    /**
     * @description: 获取参数集合
     * @Author: yangsibo
     * @Date: 2022-05-16 10:07:10
     * @param {*} id 类型
     * @return {*}
     */
    getParams(id) {
      if (id == 8) {
        return {
          manageDtos: this.dutyCheckeds,
          businessZoneId: this.areaData.id,
        };
      }
      if (id == 4) {
        return {
          ids: this.dutyIds,
          businessZoneId: this.areaData.id,
        };
      }
    },
    /**
     * @description: 新增业务区域
     * @Author: yangsibo
     * @Date: 2022-05-13 10:24:16
     */
    async insertMBusinessZone() {
      if (!this.currentForm.zoneName) {
        this.$message({
          type: "warning",
          message: "请输入区域名称",
          duration: 2000,
        });
        return false;
      }
      try {
        let { status } = await this.$http.business.insertMBusinessZone(
          this.currentForm
        );
        if (status === "1") {
          this.confirmEnd("新增业务区域成功");
        }
      } catch (error) {
        console.log(error);
      }
    },
    /**
     * @description: 修改区域名称
     * @Author: yangsibo
     * @Date: 2022-05-13 15:00:06
     */
    async updateMBusinessZoneNameById() {
      if (!this.currentForm.zoneName) {
        this.$message({
          type: "warning",
          message: "请输入区域名称",
          duration: 2000,
        });
        return false;
      }
      try {
        let { status } = await this.$http.business.updateMBusinessZoneNameById(
          this.currentForm
        );
        if (status === "1") {
          this.confirmEnd("修改名称成功");
        }
      } catch (error) {
        console.log(error);
      }
    },
    /**
     * @description: 根据id删除业务区域
     * @Author: yangsibo
     * @Date: 2022-05-13 15:25:24
     */
    async deleteMBusinessZoneNameById() {
      try {
        let { status } = await this.$http.business.deleteMBusinessZoneNameById(
          this.currentForm
        );
        if (status === "1") {
          this.confirmEnd("删除区域成功");
        }
      } catch (error) {}
    },
    /**
     * @description: 获取区域成员列表
     * @Author: yangsibo
     * @Date: 2022-05-13 16:38:31
     */
    async specifiedDutyList(businessZoneId) {
      try {
        let { data } = await this.$http.business.specifiedDutyList({
          businessZoneId,
        });
        let duty = data
          .map((val) => {
            if (val.dutyFlag) {
              return val.id;
            }
          })
          .filter((val) => {
            return val;
          });

        this.dutyIds = duty;
        this.dutyCheckeds = data.filter((val) => {
          return val.dutyFlag;
        });
        this.areaPersonList = data;
      } catch (error) {}
    },
    /**
     * @description: 设置负责人
     * @Author: yangsibo
     * @Date: 2022-05-13 17:16:55
     */
    async specifiedDuty(params) {
      try {
        let { status } = await this.$http.business.specifiedDuty(params);
        if (status === "1") {
          this.confirmEnd("设置负责人成功");
          this.areaData.flag = true;
          this.$emit("handleNodeClick", this.areaData);
        }
      } catch (error) {}
    },
    /**
     * @description: 添加业务员回显
     * @Author: yangsibo
     * @Date: 2022-05-16 08:48:04
     */
    async addPersonList(businessZoneId, callback) {
      try {
        let { data } = await this.$http.business.addPersonList({
          businessZoneId,
        });
        this.dutyPersonList = data ? data : [];
        callback && callback(data);
      } catch (error) {}
    },
    /**
     * @description: -批量添加业务员
     * @Author: yangsibo
     * @Date: 2022-05-16 10:04:32
     */
    async batchAddPerson(params) {
      try {
        let { status } = await this.$http.business.batchAddPerson(params);
        if (status === "1") {
          this.confirmEnd("添加业务员成功");
          this.$emit("getPersonListbyZoneId", this.areaData.id);
        }
      } catch (error) {}
    },
    /**
     * @description: 批量删除业务员
     * @Author: yangsibo
     * @Date: 2022-05-16 10:16:30
     * @param {*} ids 需要被删除的业务员集合
     * @return {*}
     */
    async batchDelPerson(ids) {
      ids = ids.map((item) => {
        return item.id;
      });
      try {
        let { status } = await this.$http.business.batchDelPerson({ ids });
        if (status === "1") {
          this.confirmEnd("删除业务员成功");
          this.$emit("getPersonListbyZoneId", this.areaData.id);
        }
      } catch (error) {}
    },
    /**
     * @description: 确认 结束
     * @Author: yangsibo
     * @Date: 2022-05-13 15:03:23
     * @param {*} tip 提示文案
     */
    confirmEnd(message) {
      this.$message({
        type: "success",
        message,
        duration: 2000,
      });
      this.$emit("close");
      this.$emit("getBusinessZoneList", () => {
        this.$nextTick(() => {
          this.$parent.$refs["my-tree"].setCurrentKey(this.areaData.id);
        });
      });
    },
    /**
     * @description: 选中树
     * @Author: yangsibo
     * @Date: 2022-05-13 09:32:58
     */
    handleNodeClick(data, checked) {
      if (checked) {
        this.node = data;
        this.currentForm.parentId = data.id;
        this.currentForm.orderNum = data.children
          ? data.children.length + 1
          : 1;
        this.$refs.selectTree.blur();
        this.$nextTick(() => {
          this.$refs.selectedTree.setCurrentKey(this.node.id);
        });
      }
    },

    /**
     * @description: 查询人员
     * @Author: yangsibo
     * @Date: 2022-05-13 17:51:16
     */
    handleFilter() {
      this.addPersonList(this.areaData.id, (data) => {
        this.dutyPersonList = data.filter((item) => {
          return item.fullName.includes(this.keyWord);
        });
      });
    },
    /**
     * @description: 添加业务员多选款变化
     * @Author: yangsibo
     * @Date: 2022-05-16 10:03:15
     * @param {*} value 选中值
     * @return {*}
     */
    changeDutyList(value) {
      this.dutyCheckeds = this.dutyPersonList.filter((item) => {
        return value.includes(item.id);
      });
    },
    /**
     * @description: 添加业务员多选款变化
     * @Author: yangsibo
     * @Date: 2022-05-16 10:03:15
     * @param {*} value 选中值
     * @return {*}
     */
    changeIds(value) {
      this.dutyCheckeds = this.areaPersonList.filter((item) => {
        return value.includes(item.id);
      });
    },
    /**
     * @description: 删除数组中的某个元素
     * @Author: yangsibo
     * @Date: 2022-04-07 14:24:25
     * @param {*} i 删除元素的下标
     * @param {*} arr 需要删除元素的数组
     */
    deleteItem(i, arr, item) {
      arr.splice(i, 1);
      this.dutyIds = this.dutyIds.filter((val) => {
        return val != item.id;
      });
    },
  },
  created() {},
  mounted() {
    this.initData(this.dialogObj);
  },
  watch: {
    dialogObj: {
      handler(val) {
        this.initData(val);
      },
      deep: true,
    },
  },
};
</script>
<style lang="scss">
.select-tree {
  max-height: 300px;
  .el-select-dropdown__item,
  .el-select-dropdown__item.selected,
  .el-select-dropdown__item.hover,
  .el-select-dropdown__item:hover {
    font-weight: normal;
    background: #fff;
    padding: 0;
  }
  .el-tree-node.is-current > .el-tree-node__content {
    background: #e1f4f5;
    color: #018388;
  }
  .el-tree-node__content {
    &:hover {
      background: #e1f4f5;
      color: #018388;
    }
  }
}
</style>
<style lang="scss" scoped>
.current-dialog {
  .delete-item {
    width: 100%;
    text-align: center;
    box-sizing: border-box;
    ::v-deep .el-form-item__content {
      font-size: 20px;
      font-weight: 400;
      color: #444444;
    }
  }
  .change-item {
    ::v-deep .el-form-item__content {
      font-size: 16px;
      color: #606266;
      line-height: 40px;
    }
  }
  .red-tip {
    ::v-deep .el-form-item__content {
      font-weight: 400;
      color: #f21414;
      font-size: 14px;
      line-height: 20px;
    }
  }
  .person-item {
    .person-title {
      font-size: 16px;
      font-weight: bold;
      color: #444444;
    }
    .person-content {
      width: 460px;
      height: 222px;
      border: 1px solid #e3e8eb;
      overflow: auto;
      padding: 10px;
      box-sizing: border-box;
      .person-emty {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #909399;
        font-size: 16px;
      }
      ::v-deep .el-radio-group,
      ::v-deep .el-checkbox-group {
        width: 100%;
        line-height: normal;
        .el-radio,
        .el-checkbox {
          width: 100%;
          box-sizing: border-box;
          height: 40px;
          margin: 0;
          .el-radio__input,
          .el-radio__label,
          .el-checkbox__input,
          .el-checkbox__label {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
          }
          .el-radio__input,
          .el-checkbox__input {
            right: 0;
          }
          .el-radio__label,
          .el-checkbox__label {
            left: 0;
          }
        }
      }
    }
    .selected {
      display: flex;
      align-items: center;
      .label {
        font-size: 16px;
        font-weight: 400;
        color: #444444;
      }
      .scroll {
        max-width: 430px;
        padding-top: 13px;
        ul {
          display: flex;
          flex-wrap: wrap;
          li {
            flex-shrink: 0;
            height: 32px;
            line-height: 32px;
            background: #f5f8fa;
            border: 1px solid #018388;
            border-radius: 6px;
            color: #018388;
            display: flex;
            padding: 0 12px;
            font-size: 16px;
            align-items: center;
            margin-right: 10px;
            margin-bottom: 10px;
            .txt {
              margin-right: 5px;
            }
            .el-icon-close {
              cursor: pointer;
            }
          }
        }
      }
    }
    .person-filter {
      width: 100%;
      display: flex;
      margin-bottom: 12px;
      .el-input {
        width: 220px;
        height: 38px;
        border-radius: 3px;
      }
      .filter-btn {
        width: 66px;
        height: 38px;
        background: #018388;
        border-radius: 3px;
        margin-left: 10px;
        padding: 10px;
      }
    }
  }
  .foot-btns {
    display: flex;
    justify-content: center;
    padding-top: 10px;
    .btn-cancel {
      width: 100px;
      height: 42px;
      background: #e7eaf0;
      border-radius: 3px;
      font-size: 18px;
      color: #666666;
      border: #666666;
    }
    .btn-confirm {
      width: 100px;
      height: 42px;
      background: #018388;
      border-radius: 3px;
      color: #fff;
      font-size: 18px;
    }
  }
}
</style>
